// Shared TERVIEW PDF branding — used by all download functions
import { jsPDF } from 'jspdf';

export const PDF = { W: 210, H: 297, M: 20, CW: 170 };

export const createDoc = () => new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

export const fR = (doc, r, g, b, x, y, w, h) => {
  doc.setFillColor(r, g, b); doc.rect(x, y, w, h, 'F');
};
export const sR = (doc, r, g, b, lw, x, y, w, h) => {
  doc.setDrawColor(r, g, b); doc.setLineWidth(lw); doc.rect(x, y, w, h, 'S');
};
export const T = (doc, color, size, bold, text, x, y, opts) => {
  doc.setTextColor(...color); doc.setFontSize(size);
  doc.setFont('helvetica', bold ? 'bold' : 'normal');
  doc.text(String(text), x, y, opts || {});
};
export const hLine = (doc, x1, y, x2, r, g, b, lw = 0.3) => {
  doc.setDrawColor(r, g, b); doc.setLineWidth(lw); doc.line(x1, y, x2, y);
};

// Draw the branded cover header (first page)
export const drawCoverHeader = (doc, { reportTitle, role, company, levelLabel, dateStr }) => {
  const { W, M } = PDF;
  fR(doc, 14, 9, 38, 0, 0, W, 54);
  fR(doc, 109, 40, 217, 0, 52.5, W, 2);
  T(doc, [255, 255, 255], 22, true, 'TERVIEW', M, 20);
  T(doc, [196, 181, 253], 9, false, reportTitle, M, 30);
  T(doc, [167, 139, 250], 7.5, false, 'terview.ai', M, 39);
  T(doc, [255, 255, 255], 10.5, true, role || '', W - M, 19, { align: 'right' });
  if (company) T(doc, [196, 181, 253], 8, false, company, W - M, 28, { align: 'right' });
  if (levelLabel) T(doc, [167, 139, 250], 7.5, false, levelLabel, W - M, 37, { align: 'right' });
  if (dateStr) T(doc, [130, 110, 180], 7, false, dateStr, W - M, 46, { align: 'right' });
};

// Compact header for page 2+
export const drawPageHeader = (doc, role) => {
  const { W, M } = PDF;
  fR(doc, 14, 9, 38, 0, 0, W, 13);
  fR(doc, 109, 40, 217, 0, 12.5, W, 1);
  T(doc, [255, 255, 255], 8, true, 'TERVIEW', M, 9);
  T(doc, [196, 181, 253], 7, false, role ? `${role}` : 'Report', W - M, 9, { align: 'right' });
};

// Stamped footer on every page
export const drawFooters = (doc) => {
  const { W, H, M } = PDF;
  const n = doc.getNumberOfPages();
  for (let p = 1; p <= n; p++) {
    doc.setPage(p);
    fR(doc, 14, 9, 38, 0, H - 12, W, 12);
    fR(doc, 109, 40, 217, 0, H - 12.5, W, 0.8);
    T(doc, [150, 130, 200], 7, false, 'Generated by TERVIEW  ·  AI-Powered Interview Preparation  ·  terview.ai', M, H - 5);
    T(doc, [150, 130, 200], 7, false, `Page ${p} of ${n}`, W - M, H - 5, { align: 'right' });
  }
};

// Metadata info card (key-value pairs)
export const drawMetaCard = (doc, fields, startY) => {
  const { M, CW } = PDF;
  const lineH = 5.8;
  const validFields = fields.filter(f => f.value);
  const cardH = validFields.length * lineH + 12;
  fR(doc, 246, 244, 255, M, startY, CW, cardH);
  sR(doc, 218, 213, 238, 0.3, M, startY, CW, cardH);
  fR(doc, 109, 40, 217, M, startY, 3.5, cardH);
  let ty = startY + 8;
  validFields.forEach(({ label, value }) => {
    T(doc, [75, 65, 100], 8, true, `${label}:`, M + 7, ty);
    const labelW = doc.getTextWidth(`${label}: `);
    T(doc, [35, 28, 55], 8, false, String(value), M + 7 + labelW, ty);
    ty += lineH;
  });
  return startY + cardH;
};

// Section heading divider
export const drawSectionHeading = (doc, text, y) => {
  const { M, CW } = PDF;
  T(doc, [20, 14, 50], 10, true, text, M, y);
  hLine(doc, M, y + 2.5, M + CW, 210, 205, 235, 0.5);
  return y + 9;
};
